'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import logo from 'bender-url!../../img/hubspot-tools-logo.png';

var Logo = function Logo(_ref) {
  var onClick = _ref.onClick;
  var classes = Boolean(onClick) ? "clickable" : "";
  return /*#__PURE__*/_jsx("div", {
    className: "logo",
    children: /*#__PURE__*/_jsx("img", {
      className: "" + classes,
      src: logo,
      onClick: onClick
    })
  });
};

Logo.defaultProps = {
  isClickable: false
};
export default Logo;